export default "__VITE_ASSET__DfGmA3Ax__"